export const SITE_NAME = process.env.REACT_APP_SITE_NAME || "DgBazaar";
